export const root = 'lapidary-icon2'

export const selectors = { root } as const

export const publicCSSVariables = { size: `--${root}-size` } as const
export const cssVariables = { ...publicCSSVariables } as const
